function isSafeInteger(value) {
    return Number.isSafeInteger(value);
}

export { isSafeInteger };
